/**
 * iframe 환경인지 감지하는 함수
 * @returns {boolean} iframe 환경이면 true, 아니면 false
 */
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    // Cross-origin iframe인 경우 SecurityError가 발생할 수 있음
    return true;
  }
};

/**
 * iframe 환경에 따른 연락처 정보를 반환하는 함수
 * @returns {object} 연락처 정보 객체
 */
export const getContactInfo = () => {
  const isIframe = isInIframe();
  
  if (isIframe) {
    // iframe 환경에서 사용할 영업담당자 연락처
    return {
      email: 'ai.networksolutions.kr@gmail.com',  // 영업팀 이메일
      phone: '010-3973-4365',    // 영업팀 전화번호
      isIframe: true
    };
  } else {
    // 일반 환경에서 사용할 기본 연락처
    return {
      email: 'kyle7949@sa21c.com',
      phone: '010-8626-2111',
      isIframe: false
    };
  }
};